import React from 'react'

import SvgIcon from './SvgIcon'

const ArrowUpIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m5 12l7-7l7 7m-7 7V5"
    />
  </SvgIcon>
)

export default ArrowUpIcon
